module.exports = __webpack_public_path__ + "img/footer-button.932ad76.webp";